import React from 'react';

const Login = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#f4f6f9', padding: '20px' }}>
      <div style={{ background: 'white', padding: '40px', borderRadius: '15px', boxShadow: '0 10px 25px rgba(0,0,0,0.1)', textAlign: 'center', maxWidth: '600px', width: '100%' }}>
        <h1 style={{ color: '#dc3545', marginBottom: '15px' }}>Website Temporarily Suspended</h1>
        <p style={{ color: '#555', lineHeight: 1.6, marginBottom: '10px' }}>
          This website is currently unavailable due to an outstanding service subscription/payment.
        </p>
        <p style={{ color: '#555', lineHeight: 1.6, marginBottom: '10px' }}>
          Access will be restored immediately once the pending payment is completed.
        </p>
        <div style={{ marginTop: '20px', fontWeight: 'bold', color: '#333' }}>
          Please contact the website administrator for assistance.
        </div>
        <div style={{ marginTop: '20px', fontSize: '14px', color: '#888' }}>
          Thank you for your understanding.
        </div>
      </div>
    </div>
  );
};

export default Login;

